import { createSlice } from '@reduxjs/toolkit';

export const fontListSlice = createSlice({
  name: 'fontList',
  initialState: {
    recommendedFontList: [],
    recommendedFontListFromMd5: [],
    isFontLoading: false,
    isFontError: false,
    errorFontListMessage: '',
    EditFontList: [],
    isEditFontLoading: false,
    isEditFontError: false,
    errorEditFontListMessage: '',
    lastPayloadForUrlMd5: '',
    lastPayloadForUrlFontFamlily: '',
    lastPayloadForUrlFontName: '',
    lastPayloadForInventories:null,
  },
  reducers: {
    setFontLoading: (state, action) => {
      state.isFontLoading = action.payload;
      state.isFontError = false;
      state.errorFontListMessage = '';
    },
    setRecommendedFontList: (state, action) => {
      state.recommendedFontList = action.payload;
      state.isFontLoading = false;
      state.isFontError = false;
      state.errorFontListMessage = '';
    },
    setFontError: (state, action) => {
      state.isFontError = true;
      state.errorFontListMessage = action.payload;
      state.isFontLoading = false;
    },
    setClearFontError: (state) => {
      state.isFontError = false;
      state.errorFontListMessage = '';
    },
    setEditFontLoading: (state, action) => {
      state.isEditFontLoading = action.payload;
      state.isEditFontError = false;
      state.errorEditFontListMessage = '';
    },
    setEditFontList: (state, action) => {
      state.EditFontList = action.payload;
      state.isEditFontLoading = false;
      state.isEditFontError = false;
      state.errorEditFontListMessage = '';
    },
    setEditFontError: (state, action) => {
      state.isEditFontError = true;
      state.errorEditFontListMessage = action.payload;
      state.isEditFontLoading = false;
    },
    setRecommendedFontListFromMd5: (state, action) => {
      state.recommendedFontListFromMd5 = action.payload;
    },
    setLastPayloadForUrlMd5: (state, action) => {
      state.lastPayloadForUrlMd5 = action.payload.urlMd5;
      state.lastPayloadForUrlFontFamlily = action.payload.fontFamilyUrl;
      state.lastPayloadForInventories = action.payload.inventories;
      state.lastPayloadForUrlFontName = action.payload.fontNameFromParams;
    },
  },
});

export const {
  setFontLoading,
  setFontError,
  setRecommendedFontList,
  setClearFontError,
  setEditFontLoading,
  setEditFontList,
  setEditFontError,
  setRecommendedFontListFromMd5,
  setLastPayloadForUrlMd5,
} = fontListSlice.actions;

export default fontListSlice.reducer;
